import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, User, LogOut, Package, Search } from "lucide-react";
import { useStore } from "../../pages/market/StoreShell";
import { BuyerAuthDialog } from "./BuyerAuthDialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

export const StoreHeader = ({ query, setQuery }) => {
  const { slug, store, count, buyer, setBuyer, setAuthOpen } = useStore();
  const [showSearch, setShowSearch] = useState(false);
  const t = store.texts || {};
  return (
    <>
      {t.announcement && (
        <div className="px-4 py-2 text-center text-xs font-medium text-white" style={{ background: "var(--mk-primary)", color: "var(--mk-on-primary)" }} data-testid="store-announcement">
          {t.announcement}
        </div>
      )}
      <header className="safe-top sticky top-0 z-40 border-b border-black/5 backdrop-blur-xl" style={{ background: "color-mix(in srgb, var(--mk-surface) 88%, transparent)" }}>
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-3">
          <Link to={`/m/${slug}`} className="flex min-w-0 items-center gap-2.5" data-testid="store-logo-link">
            {store.theme?.logo ? (
              <img src={store.theme.logo} alt={store.name} className="h-9 w-auto max-w-[140px] object-contain" />
            ) : (
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-base font-bold text-white" style={{ background: "var(--mk-primary)", color: "var(--mk-on-primary)" }}>
                {store.name[0]}
              </span>
            )}
            <span className="truncate text-base font-bold">{store.name}</span>
          </Link>
          <div className="flex-1" />
          {setQuery && (
            <div className={`${showSearch ? "flex" : "hidden"} absolute inset-x-3 top-[calc(100%+6px)] sm:static sm:flex`}>
              <div className="relative w-full sm:w-64">
                <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 opacity-50" />
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Buscar productos"
                  className="w-full rounded-full border border-black/10 bg-white py-2.5 pl-9 pr-4 text-sm text-slate-900 shadow-sm outline-none focus:ring-2 focus:ring-[var(--mk-primary)]"
                  data-testid="store-search-input"
                />
              </div>
            </div>
          )}
          {setQuery && (
            <button onClick={() => setShowSearch((v) => !v)} className="rounded-full p-2.5 hover:bg-black/5 sm:hidden" data-testid="store-search-toggle">
              <Search className="h-5 w-5" />
            </button>
          )}
          {buyer ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex h-10 w-10 items-center justify-center rounded-full bg-black/5 text-sm font-bold" data-testid="store-account-menu">
                  {buyer.buyer?.name?.[0]?.toUpperCase() || <User className="h-5 w-5" />}
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem asChild>
                  <Link to={`/m/${slug}/mis-pedidos`} data-testid="store-my-orders-link">
                    <Package className="mr-2 h-4 w-4" /> Mis pedidos
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setBuyer(null)} data-testid="store-logout">
                  <LogOut className="mr-2 h-4 w-4" /> Cerrar sesión
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <button onClick={() => setAuthOpen(true)} className="rounded-full p-2.5 hover:bg-black/5" data-testid="store-login-button" aria-label="Iniciar sesión">
              <User className="h-5 w-5" />
            </button>
          )}
          <Link
            to={`/m/${slug}/carrito`}
            className="relative flex h-10 items-center gap-1.5 rounded-full px-3.5 text-sm font-semibold text-white shadow-md transition-transform active:scale-95"
            style={{ background: "var(--mk-primary)", color: "var(--mk-on-primary)" }}
            data-testid="store-cart-button"
          >
            <ShoppingBag className="h-4 w-4" />
            <span data-testid="store-cart-count">{count}</span>
          </Link>
        </div>
      </header>
      <BuyerAuthDialog />
    </>
  );
};
